<template>
  <h5 class="Vlt-sidemenu__title">{{label}}</h5>
</template>

<script>
export default {
  name: 'VltSidemenuTitle',

  props: {
    label: String,
  },
};
</script>
